/**
 * Matches any `${...}` template placeholder: numeric (`${Var1}`) and
 * named (`${AGENT_FIRST_NAME}`) alike. Non-global on purpose — a shared
 * global regex keeps `lastIndex` state between `.test()` calls.
 */
const TEMPLATE_PLACEHOLDER_REGEX = /\$\{[\w_]+\}/;

const hasPlaceholders = (text?: string | null): boolean =>
  !!text && TEMPLATE_PLACEHOLDER_REGEX.test(text);

export default hasPlaceholders;
